import { css } from '@emotion/react';
import { widgetStyles } from '@sitebuilder/common';

const iconIndicatorStyles = css`
    .inactive-icons {
        display: inline-block;
        position: relative;
        color: ${widgetStyles.themeVars['$color-grey']};
    }

    .active-icons {
        position: absolute;
        top: 0;
        left: 0;
        white-space: nowrap;
        overflow: hidden;
        width: 0;
        color: ${widgetStyles.themeVars['$color-black']};
    }
`;

export const themeIconIndicatorStyles = css`
    .inactive-icons {
        display: inline-block;
        position: relative;
        color: var(--color-grey);
    }

    .active-icons {
        position: absolute;
        top: 0;
        left: 0;
        white-space: nowrap;
        overflow: hidden;
        width: 0;
        color: var(--color-black);
    }
`;

export default iconIndicatorStyles;
